import moment from 'moment-timezone';
import { FORMAT_DATE_US_TIME_ZONE } from '../../constants/common';
import {
  AccessCodeRecordInterface,
  AccessCodeStatus,
  SubscriptionDuration,
  SubscriptionDurationValue,
  SubscriptionPlan,
  SubscriptionPlanValue,
} from '../../types/accessCode';

export const toSubscriptionPlan = (plan: number) => {
  let subscriptionPlan = '';
  switch (plan) {
    case 1:
      subscriptionPlan = SubscriptionPlan.CHAMPION;
      break;
    case 2:
      subscriptionPlan = SubscriptionPlan.LEGEND;
      break;
    default:
      subscriptionPlan = SubscriptionPlan.LEGEND;
      break;
  }

  return subscriptionPlan;
};

export const toSubscriptionDuration = (duration: number) => {
  let subscriptionDuration = '';
  if (duration % 12 === 0) {
    subscriptionDuration = SubscriptionDuration.YEARLY;
  } else {
    subscriptionDuration = SubscriptionDuration.MONTHLY;
  }

  return subscriptionDuration;
};

export const toAccessCodeListCsv = (accessCodeList: AccessCodeRecordInterface[], status?: AccessCodeStatus) => {
  if (accessCodeList.length === 0) {
    return [
      {
        index: '',
        code: '',
        subscriptionPlan: '',
        subscriptionDuration: '',
        createdAt: '',
      },
    ];
  }
  return accessCodeList.map((item: AccessCodeRecordInterface, index: number) => {
    const result = {
      no: index + 1,
      code: item.code,
      subscriptionPlan:
        SubscriptionPlanValue.CHAMPION === item.subscriptionPlan ? SubscriptionPlan.CHAMPION : SubscriptionPlan.LEGEND,
      subscriptionDuration: `${
        item.subscriptionDuration <= 11 ? SubscriptionDuration.MONTHLY : SubscriptionDuration.YEARLY
      } (${item.subscriptionDuration} month)`,
      createdAt: item.createdAt ? moment(item.createdAt).format(FORMAT_DATE_US_TIME_ZONE) : null,
    };

    if (status !== AccessCodeStatus.AVAILABLE) {
      return {
        ...result,
        purpose: item.target,
        usedDate: item.usedDate ? moment(item.usedDate).format(FORMAT_DATE_US_TIME_ZONE) : null,
        firstName: item?.firstName,
        lastName: item?.lastName,
        email: item?.email,
      };
    }

    return result;
  });
};

export const fileNameCsv = () => {
  return `${moment().format('YYYYMMDD_hhmmss')}_Access_Code.csv`;
};

export const toSubscriptionValue = (durationValue: SubscriptionDurationValue, inputDuration: number) => {
  let duration;
  switch (durationValue) {
    case SubscriptionDurationValue.ALL:
      duration = undefined;
      break;
    case SubscriptionDurationValue.INPUT:
      duration = inputDuration;
      break;
    case SubscriptionDurationValue.MONTHLY:
    case SubscriptionDurationValue.YEARLY:
      duration = durationValue;
      break;
    default:
      duration = durationValue;
      break;
  }
  return duration;
};
